(function($) {
    $(".lib--parallax").find("img:not(.lazyload)").parent().parallax();

    $doc.on('lazybeforeunveil', function(e){
        if ($(e.target).parent().hasClass("lib--parallax")) {
            $(e.target).parent().parallax();
        }
        $(e.target).one('load', function() {
            if ($(this).parent().hasClass("lib--lazyload")) {
                $(this).parent().removeClass("lib--lazyload").addClass("lib--lazyloaded");
            }
        });
    });

    $(".lazyloaded").each(function(){
        if ($(this).parent().hasClass("lib--lazyload")) {
            $(this).parent().removeClass("lib--lazyload").addClass("lib--lazyloaded");
        }
    });

    $(".part_ui_btn").nl_lib_ripple();
    fn_nl_lib_anchor();

    var $lightgallery = $("[data-lightgallery]");

    if ($lightgallery) {
        $lightgallery.lightGallery({
            thumbnail: true,
            selector: ".elm_item",
            exThumbImage: 'data-exthumbimage',
            fullScreen: true,
            zoom: true,
            actualSize: false,
            hash: false,
            download: true,
            autoplay: false,
            autoplayControls: false
        });
    }

    var picture = document.createElement('picture'),
        strObj = '' + picture;
    if(strObj.indexOf("HTMLPictureElement") === -1 && !$html.hasClass("ie"))
    {
        $.getScript($cdnjs.picturefill);
    }
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
        $html.addClass("ie11");
    }
})(jQuery);